export const WorkflowsVals = {
  ProjectDocumentationApproval: 1,
  WorkingDocumentationApproval: 2,
  TechSpecsApproval: 3,
  TechSpecsChangesApproval: 4,
  DocsCompletionConfirmation: 5,
  TSTSCAffirmation: 6,
  SendToArchive: 7,
  OriginalData: 8, // Исходные данные
  Executive: 9,
  InitialPermitDocumentationApproval: 10,
  PaperSigning: 11,
}
